import { render, staticRenderFns } from "./AskAIButton.vue?vue&type=template&id=34f48cde&scoped=true&"
import script from "./AskAIButton.vue?vue&type=script&lang=js&"
export * from "./AskAIButton.vue?vue&type=script&lang=js&"
import style0 from "./AskAIButton.vue?vue&type=style&index=0&id=34f48cde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f48cde",
  null
  
)

export default component.exports